import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import Pagination from "react-js-pagination";
import Select from "react-dropdown-select";
import { isMobile } from "react-device-detect";
import CommonImage from "../../CommonComponent/CommonImage";
import ResultMsg from "./ResultMsg";
import FavoriteNames from "./FavoriteNames";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";

const defaultpage = 1;
const defaultpageperitem = 10;
const defaultvalue = "";

let favNamesData = [];

const Results = (props) => {
  const [showAllNames, setShowAllNames] = useState(true);
  const [showFavNames, setShowFavNames] = useState(false);
  const [favNames, setFavNames] = useState([]);
  const [counter, setCounter] = useState(0);
  /* Assign Variable for Pagination */
  const [currentPage, setCurrentPage] = useState(defaultpage);
  //Navigate to the page
  const paginate = (pageNumber) => {
    setPagination({
      ...pagination,
      currentPage: pageNumber,
    });
    props.paginate(pageNumber);
  };

  const [resultdata, setResultdata] = useState({
    results: [],
    paginatedata: {},
    searchtext: "",
  });
  const [pagination, setPagination] = useState();
  const [pagesize, setPagesize] = useState({
    optionvalue: "",
    placeholder: "",
  });
  const [ddstate, setDdstate] = useState("dclose");
  const [showFilterBlk, setShowFilterBlk] = useState(false);

  //const combined = []

  // useEffect(() => {
  //   setResultdata({

  //   })
  // },[resultdata])

  useEffect(() => {
    let pageperitem = sessionStorage.getItem("pageperitem")
      ? sessionStorage.getItem("pageperitem")
      : props.paginatedata.itemsPerPage;
    let placeholder =
      props.pageSize &&
      props.pageSize !== null &&
      props.pageSize.map(
        (data) =>
          parseInt(data.fields.key.value) === parseInt(pageperitem) &&
          data.fields.name.value
      );
    let optionvalue =
      props.pageSize &&
      props.pageSize !== null &&
      props.pageSize.map((data) => ({
        value: data.fields.key.value,
        label: data.fields.name.value,
      }));

    setPagesize({
      optionvalue: optionvalue,
      placeholder: placeholder.filter((res) => res !== false && res),
    });
    setFavNames(JSON.parse(sessionStorage.getItem("favNames")));
  }, []);

  useEffect(() => {
    setFavNames(JSON.parse(sessionStorage.getItem("favNames")));
    let searchtext = props.resultData && props.searchtext;
    let datas = props.resultData && props.resultData;
    let pagination = props.paginatedata && props.paginatedata;
    datas !== undefined &&
      datas !== null &&
      datas !== "" &&
      pagination !== undefined &&
      pagination !== null &&
      pagination !== "" &&
      updateData(datas, pagination, searchtext);
    return updateData(datas, pagination, searchtext);
  }, [props.resultData]);

  // useEffect(() => {
  //   let filterlist = props.filters && props.filters.map(data => data.filterItems.filter(item => item.filterItemIsSelected !== false))
  //   /* let result = filterlist.filter(data => data.length > 0)
  //   combined.push(result.filter((data,i) => data !== null && data !== undefined))
  //   console.log(combined) */
  //   let itemlist = filterlist.filter(list => list.length !== 0)
  //   itemlist.length > 0 ? setShowFilterBlk(true) : setShowFilterBlk(false)
  // },[props.filters])
  const updateData = (datas, pagination, searchtext) => {
    setResultdata({
      results: datas,
      totalCount: pagination.totalCount,
      itemsPerPage: pagination.itemsPerPage,
      numberOfPages: pagination.numberOfPages,
      currentPage: pagination.currentPage,
      searchtext: searchtext,
    });
    let pageperitem = sessionStorage.getItem("pageperitem")
      ? sessionStorage.getItem("pageperitem")
      : props.paginatedata.itemsPerPage;
    let placeholder =
      props.pageSize &&
      props.pageSize !== null &&
      props.pageSize.map(
        (data) =>
          parseInt(data.fields.key.value) === parseInt(pageperitem) &&
          data.fields.name.value
      );
    let optionvalue =
      props.pageSize &&
      props.pageSize !== null &&
      props.pageSize.map((data) => ({
        value: data.fields.key.value,
        label: data.fields.name.value,
      }));
    setPagesize({
      optionvalue: optionvalue,
      placeholder: placeholder.filter((res) => res !== false && res),
    });
  };

  const onChange = (result) => {
    sessionStorage.setItem("currentPage", 1);
    sessionStorage.setItem("pageperitem", result[0].value);
    props.itemsperpage(result[0].value);
  };

  const clearallfilter = () => {
    props.clearallfilter([]);
  };

  const addToFav = (data) => {
    // if(props.tabData.data.key.value === 'MIDDLE_NAME'){
    //   data.firstName = data.firstName + ' ' +data.lastName
    // }
    let tempData = JSON.parse(JSON.stringify(data));
    let checkItem = [];
    if (favNamesData.length === 0) {
      tempData.isFav = true;
      favNamesData.push(tempData);
    } else {
      checkItem = favNamesData.filter((item) => {
        if (
          item.firstName === tempData.firstName &&
          item.middleName === tempData.middleName
        ) {
          return item;
        }
      });
      if (checkItem.length === 0) {
        tempData.isFav = true;
        favNamesData.push(tempData);
      } else if (checkItem.length > 0) {
        checkItem = favNamesData.filter((item) => {
          if (
            item.firstName !== tempData.firstName ||
            item.middleName !== tempData.middleName
          ) {
            item.isFav = false;
            return item;
          }
        });
        favNamesData = checkItem;
      }
    }
    console.log(favNamesData);
    setFavNames(favNamesData);
    sessionStorage.setItem("favNames", JSON.stringify(favNamesData));
    let tempResult = resultdata.results.map((item, index) => {
      if (
        item.firstName === data.firstName &&
        item.middleName === tempData.middleName
      ) {
        if (data.isFav) item.isFav = false;
        else item.isFav = true;
      }
      return item;
    });
    setResultdata({
      results: tempResult,
      totalCount: resultdata.totalCount,
      itemsPerPage: resultdata.itemsPerPage,
      currentPage: resultdata.currentPage,
    });
    // console.log(tempData)
  };

  const removeFromFav = (data) => {
    let tempData = JSON.parse(JSON.stringify(data));
    let checkItem = [];
    if (favNamesData.length === 0) {
      tempData.isFav = true;
      favNamesData.push(tempData);
    } else {
      checkItem = favNamesData.filter((item) => {
        if (
          item.firstName === tempData.firstName &&
          item.middleName === tempData.middleName
        ) {
          return item;
        }
      });
      if (checkItem.length === 0) {
        tempData.isFav = true;
        favNamesData.push(tempData);
      } else if (checkItem.length > 0) {
        checkItem = favNamesData.filter((item) => {
          if (
            item.firstName + item.middleName !==
            tempData.firstName + tempData.middleName
          ) {
            // item.isFav = false
            return item;
          }
        });
        favNamesData = checkItem;
      }
    }
    console.log(favNamesData);
    setFavNames(favNamesData);
    sessionStorage.setItem("favNames", JSON.stringify(favNamesData));
    let tempResult = resultdata.results.map((item, index) => {
      if (
        item.firstName === data.firstName &&
        item.middleName === data.middleName
      ) {
        if (data.isFav) item.isFav = false;
        else item.isFav = true;
      }
      return item;
    });
    setResultdata({
      results: tempResult,
      totalCount: resultdata.totalCount,
      itemsPerPage: resultdata.itemsPerPage,
      currentPage: resultdata.currentPage,
    });
    setCounter(counter + 1);
    // console.log(tempData)
  };

  const setNamesTab = (tabName) => {
    console.log(tabName);
    if (tabName === "all") {
      setShowAllNames(true);
      setShowFavNames(false);
    } else {
      setShowAllNames(false);
      setShowFavNames(true);
    }
  };

  const { t } = props;
  return (
    <div className="searchresult searchresult-activityfinder searchresult-babyNameFinder">
      <div className="container">
        {/* {props.paginatedata.error && props.paginatedata.error.value} */}
        {showAllNames  &&(
          <div className="countercontainer">
            <h3>
              {
                props.paginatedata.error != null &&
                props.paginatedata.error.value != null
                  ? props.paginatedata.error.value
                  : props.searchData != null &&
                    props.searchData.resultMessage != null &&
                    props.searchtext != "" && props.paginatedata.totalCount > 0 
                  ? props.searchData.resultMessage.value
                      .replace("{resultCount}", props.paginatedata.totalCount)
                      .replace("{searchTerm}", `'${props.searchtext}'`)
                  :""
              }
            </h3>
          </div>
        )}
        {showAllNames &&
          !props.isFullMatch  &&
          props.tabData.data.key.value !== "MIDDLE_NAME" &&
          props.paginatedata.totalCount < 1 && (
            <div className="no-results-sorry">
              <ResultMsg
                totalCount={resultdata.totalCount}
                similarResultMessage={
                  props.searchData != null &&
                  props.searchData.similarResultMessage != null &&
                  props.searchData.similarResultMessage.value != null &&
                  props.searchData.similarResultMessage.value
                }
                searchtext={props.searchtext}
                noResultMessage={
                  props.searchData != null &&
                  props.searchData.noResultMessage != null &&
                  props.searchData.noResultMessage.value
                }
              />
            </div>
          )}
        {showAllNames &&
          props.tabData.data.key.value === "MIDDLE_NAME" &&
          props.paginatedata.totalCount < 1 && (
            <div className="no-results-sorry">
              <ResultMsg
                totalCount={resultdata.totalCount}
                similarResultMessage={
                  props.searchData != null &&
                  props.searchData.similarResultMessage != null &&
                  props.searchData.similarResultMessage.value != null &&
                  props.searchData.similarResultMessage.value
                }
                searchtext={props.searchtext}
                noResultMessage={
                  props.searchData != null &&
                  props.searchData.noResultMessage != null &&
                  props.searchData.noResultMessage.value
                }
              />
            </div>
          )}
        {props.resultData && (
          <div className="babyNameFilter">
            <div className="fav-result-filter-btns">
              <div className="all-fav-filter-btns">
                <div className="buttonWrapper">
                  <button
                    className={
                      showAllNames
                        ? "btn btn-filter-name btn-filter-selected"
                        : "btn btn-filter-name"
                    }
                    onClick={() => setNamesTab("all")}
                  >
                    {props.componentData.allNamesLabel.value}
                  </button>
                </div>
                <div className="buttonWrapper">
                  <button
                    className={
                      showFavNames
                        ? "btn btn-filter-name btn-filter-selected"
                        : "btn btn-filter-name"
                    }
                    onClick={() => setNamesTab("fav")}
                  >
                    {props.componentData.favouriteNamesLabel.value}
                  </button>
                </div>
              </div>

              {showFavNames && (
                <div className="social-share-container">
                  <div className="email-share-container">
                    <p className="share-email-text-msg">
                      Share the shorlisted names with your family and friends!
                    </p>
                    <div
                      className={
                        favNames
                          ?favNames.length > 0
                          ? ""
                          :"social-share-disable"
                          : "social-share-disable"
                      }
                    >
                      <Placeholder
                        name="social-share-result"
                        rendering={props.rendering}
                        itemid={props.itemid}
                        favNameShareResult={true}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {showAllNames && props.resultData && !isMobile && (
          <table className="nameResultTable">
            <thead>
              <tr>
                <th className="nameResultTableHeading">
                  {props.componentData.nameColumnLabel.value}
                </th>
                <th className="nameResultTableHeading">
                  {props.componentData.genderColumnLabel.value}
                </th>
                <th className="nameResultTableHeading">
                  {props.componentData.originColumnLabel.value}
                </th>
                <th className="nameResultTableHeading">
                  {props.componentData.meaningColumnLabel.value}
                </th>
                <th className="nameResultTableHeading favourite"></th>
              </tr>
            </thead>
            <tbody>
              {resultdata.results &&
                resultdata.results.map((data, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "" : "grey-background"}
                  >
                    <td className="nameResultTableContent">
                      {data.firstName}
                      {data.middleName && (
                        <span className="middleNameText">
                          {" " + data.middleName}
                        </span>
                      )}
                    </td>
                    <td className="nameResultTableContent">
                      <div className="genderIcon">
                                          {data.genderImage != null && (
                                              <CommonImage imageIcon={data.genderImage.src} />
                                          )}
                      </div>
                    </td>
                    <td className="nameResultTableContent">{data.origin}</td>
                    <td className="nameResultTableContent">{data.meaning}</td>
                    <td
                      className="nameResultTableContent"
                      onClick={
                        !data.isFav
                          ? () => addToFav(data)
                          : () => removeFromFav(data)
                      }
                    >
                      {showFavNames && (
                        <div className="favIcon">
                          <span className="fa fa-trash"></span>
                        </div>
                      )}

                      <div className="favIcon">
                        {data.isFav ? (
                          <span className="fa fa-heart"></span>
                        ) : (
                          <span className="fa fa-heart-o"></span>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
        {showAllNames && props.resultData && isMobile && (
          <div>
            <div>
              {resultdata.results &&
                resultdata.results.map((data, index) => (
                  <div
                    key={index}
                    className={index % 2 === 0 ? "" : "grey-background"}
                  >
                    {/* <td className="nameResultTableContent">{data.firstName}</td> */}
                    <div className="container-card-tile">
                      <div className="card">
                        {/* <img className="card-img-top" src="img_avatar1.png" alt="Card image"/> */}
                        <div className="card-body">
                          <div className="card-header-top">
                            <div className="card-header-right">
                                                      <div className="genderIcon">
                                                          {data.genderImage != null && (
                                                              <CommonImage imageIcon={data.genderImage.src} />
                                                         )}
                                                      </div>
                              <div className="babyNameText">
                                <p className="babyFirstNameText">
                                  {data.firstName}
                                  {data.middleName && (
                                    <span className="middleNameText">
                                      {" " + data.middleName}
                                    </span>
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="card-header-left">
                              <div
                                className="favIcon"
                                onClick={
                                  !data.isFav
                                    ? () => addToFav(data)
                                    : () => removeFromFav(data)
                                }
                              >
                                {data.isFav ? (
                                  <span className="fa fa-heart"></span>
                                ) : (
                                  <span className="fa fa-heart-o"></span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="card-body-content">
                            <div className="card-body-content-detail">
                              <p className="content-label">
                                {props.componentData.originColumnLabel.value}
                              </p>
                              <p className="content-label-text">
                                {data.origin}
                              </p>
                            </div>
                            <div className="card-body-content-detail">
                              <p className="content-label">
                                {props.componentData.meaningColumnLabel.value}
                              </p>
                              <p className="content-label-text">
                                {data.meaning}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
        {showFavNames && favNames && favNames.length > 0 ? (
          <FavoriteNames
            favNames={favNames}
            componentData={props.componentData}
            removeFromFav={removeFromFav}
            counter={counter}
            pageSize={props.pageSize}
          />
        ) : (
          <div>
            {showFavNames &&
              "No names has been added to the Favorite Names List yet."}
          </div>
        )}
        <div className="paginate-blk">
          {showAllNames &&
            pagesize.optionvalue &&
            resultdata.totalCount > Number(pagesize.optionvalue[0].value) && (
              <Select
                className={ddstate}
                onChange={onChange}
                placeholder={pagesize.placeholder}
                options={pagesize.optionvalue}
                separator={false}
                dropdownHandle={false}
                onDropdownOpen={() => setDdstate("dopen")}
                onDropdownClose={() => setDdstate("dclose")}
                dropdownPosition="auto"
              />
            )}
          {showAllNames && resultdata.totalCount > resultdata.itemsPerPage && (
            <Pagination
              hideFirstLastPages
              hideDisabled
              activePage={resultdata.currentPage}
              itemsCountPerPage={parseInt(resultdata.itemsPerPage)}
              totalItemsCount={resultdata.totalCount}
              onChange={paginate}
              pageRangeDisplayed={isMobile ? 3 : 4}
              prevPageText={
                <i className="fa fa-angle-left" aria-hidden="true"></i>
              }
              nextPageText={
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(Results);
